import * as crawler2 from "./crawler";
import * as crawlerTask from "./crawlerTask";

export const crawler = {
  crawler: crawler2,
  crawlerTask,
};
